import pattern from 'patterns/asciiEmoji';
import { WCCContentEmojiBlock } from '../blocks/emoji/emoji';
import WCCContentPatternRule from './pattern';

const emojione = require('emojione');
const { disableEmojis, asciiEmojiBlackList } = settings;

export default class WCCContentASCIIEmojiRule extends WCCContentPatternRule {
    protected pattern = pattern;
    protected override prefix = /^|\s/;
    protected override postfix = /[\s\.\n]|$/;

    protected process([content, ascii]: RegExpExecArray) {
        if (!_(asciiEmojiBlackList).contains(ascii)) {
            var unicode = _(emojione.asciiList).find((unicode, value) => value === ascii);

            if (unicode != undefined) {
                var name = _(emojione.emojioneList).findKey(emoji => _(emoji).contains(unicode));

                if (name)
                    return new WCCContentEmojiBlock({ content, name });
            }
        }
    };

    protected override checkIfDisabled() {
        return disableEmojis;
    }
}